<template>
    <div class="income-scheduling-view position-relative">
        <div class="calendar-loading" v-if="loading">
            <i class="material-icons loading-icon-size">cached</i>
        </div>
        <CalendarView
            :initial-month="currentMonth"
            :reference-date="now"
            :on-month-change="handleMonthChange"
            :render-date="renderDate"
        ></CalendarView>
    </div>
</template>

<script>
import { requestJson, formatCents } from '../helpers';
import CalendarView from './CalendarView';
import DisplayCalendar from './mixins/DisplayCalendar';
import RequestCount from './mixins/RequestCount';

export default {
    mixins: [
        DisplayCalendar,
        RequestCount
    ],
    components: {
        CalendarView
    },
    props: {
        monthSearchUrl: String,
        dateField: String,
        dateEquivalence: String,
    },
    methods: {
        async requestMonthData(){
            if (this.currentInterval == null) {
                return;
            }

            const [
                { dateString: from },
                { dateString: to }
            ] = this.currentInterval;

            const params = { from, to, date_field: this.dateField, date_equivalence: this.dateEquivalence };

            this.addRequestCount();

            try {
                const arr = await requestJson(this.monthSearchUrl, params);
                this.monthlyIndex = arr.reduce((carry, { date, statements }) => ({ ...carry, [date]: statements }), this.monthlyIndex);
            } finally {
                this.subRequestCount();
            }
        },
        renderDate(date, createElement){
            const statement = this.monthlyIndex[date.dateString];

            if(!statement){
                return;
            }

            const {
                creditAmountCents,
                debitAmountCents,
                totalAmountCents,
                dateIntervalStatementUrl
            } = statement;

            const statementValues = (creditAmountCents && debitAmountCents ? createElement('div', { 'class': 'statement-group d-none d-xl-block' }, [
                createElement('span', { 'class': 'statement-credit statement-size' }, formatCents(creditAmountCents, false)),
                createElement('span', { 'class': 'statement-debit statement-size' }, formatCents(debitAmountCents, false)),
            ]) : '');

            return createElement('a', { 'attrs': { 'class': 'statement-link', 'href': dateIntervalStatementUrl}}, [
                createElement('div', { 'class': 'statement' }, [
                    createElement('div', { 'class': 'statement-total' }, [
                        createElement('span', { 'class': 'statement-size' },'Total (R$)'),
                        createElement('span', { 'class': (totalAmountCents > 0 ? 'statement-credit' : (totalAmountCents < 0 ? 'statement-debit' : '')) + ' statement-total' }, formatCents(totalAmountCents, false))
                    ]), statementValues
                ])
            ]);
        }
    }
}
</script>

<style lang="scss">
.income-scheduling .date-anchor .statement {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.income-scheduling-view{
    .statement-link{
        color: #000000;
        text-decoration: none;
    }
    .statement-group{
        line-height: 21px;
        text-align: right;
        padding-top: 1px;
    }
    .statement-total{
        display: block;
        flex: 2;
        text-align: left;
    }
}
.income-scheduling-view{
    .statement{
        display: flex;
        padding-top: 15px;

        .statement-size{
            display: block;
            font-size: 14px;
        }
        .statement-credit{
            color: #31aa52;
        }
        .statement-debit{
            color: #eb4132;
        }
        .statement-total{
            font-size: 17px;
        }
    }
}
</style>
